import React from 'react';
import useGameStore from '../../store/gameStore';
import { CLIENT_BY_ID, getLoyaltyTier } from '../../data/clientLoyalty';

/**
 * Small tier badge rendered next to the senderName of a client message.
 * Resolves the current tier from the live `state.clientLoyalty` so the
 * badge stays in sync as the relationship evolves.
 *
 * Props :
 *   - clientId : recurring-client id (e.g. 'cli-translog'). Use the
 *     `senderId` of the message (populated by messageSlice.tickMessages
 *     when binding a tier-aware template).
 *   - size     : 'sm' | 'md' (default 'sm').
 */
export default function ClientTierBadge({ clientId, size = 'sm' }) {
  const score = useGameStore(s => s.clientLoyalty?.[clientId]?.score);
  if (clientId == null || !CLIENT_BY_ID[clientId]) return null;
  if (typeof score !== 'number') return null;
  const tier = getLoyaltyTier(score);
  if (!tier) return null;
  const cls = size === 'md'
    ? 'text-[11px] px-2 py-0.5'
    : 'text-[9px] px-1.5 py-[1px]';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-bold ${cls}`}
      style={{
        color: tier.color,
        backgroundColor: `${tier.color}1a`,
        borderColor: `${tier.color}40`,
      }}
      data-testid={`tier-badge-${clientId}`}
      title={`Niveau de fidélité : ${tier.label} (${Math.round(score)}/100)`}
    >
      {tier.label}
    </span>
  );
}
